import { Button, SxProps, Theme } from "@mui/material";
import { OnKey } from "./dialog";
import { UseEntityStore } from "./entityStore";

export function SaveButton(props: { save(): void; disabled: boolean; text?: string; disableEnter?: boolean; color?: "warning", sx?: SxProps<Theme>; }) {
    return <>
        {!props.disableEnter && <OnKey keyName="Enter" callback={() => { !props.disabled && props.save(); }} />}
        <Button sx={props.sx} onClick={props.save} disabled={props.disabled} color={props.color ?? "save"}>{props.text ?? "Save"}</Button>
    </>;
}

export function EntityStoreSaveButton<T>(props: {
    useStore: UseEntityStore<T>;
    text?: string;
    disableEnter?: boolean;
    customSave?(save: (ignoreSaveDisabled: boolean) => void): void;
    forceEnabled?: boolean;
    color?: "warning";
    sx?: SxProps<Theme>;
}) {
    const { isSaveDisabled, save } = props.useStore(p => ({ isSaveDisabled: p.isSaveDisabled, save: p.saveEx }));
    return <SaveButton save={() => props.customSave ? props.customSave(save) : save(false)} disabled={isSaveDisabled && !props.forceEnabled} text={props.text}
        disableEnter={props.disableEnter} color={props.color} sx={props.sx} />;
}
